import { useCallback } from 'react';
import { useAtomValue } from 'jotai';
import { LabellingCuboid } from '@/types';
import { convertRgbaToRgb } from '@/utils';
import * as state from '@/components/AssetLabelling/state';

const DEFAULT_CUBOID_COLOR = 0xffffaa;

export const useGetCuboidColor = () => {
  const cuboidClassById = useAtomValue(state.cuboidClassById);

  const getCuboidColor = useCallback(
    (cuboid: LabellingCuboid) =>
      cuboidClassById && cuboidClassById[cuboid.cuboidClassId]
        ? convertRgbaToRgb(cuboidClassById[cuboid.cuboidClassId].color)
        : DEFAULT_CUBOID_COLOR,
    [cuboidClassById]
  );

  return getCuboidColor;
};
